import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    paddingLeft: 0,
    paddingRight: 1,
    paddingBottom: 0,
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
    fontSize: 32,
  },
  image: {
    width: '200px',
  },
}));

